import React, { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  selectProductForEditing,
  fetchProduct,
  setProductForEdit,
  selectLoading,
  updateProduct,
  updateMultisplit,
} from "../productsAdminSlice";
import { createProduct } from "./utils";
import AdminForm from "../../AdminForm";
import { fetchAllTags, selectAllTags } from "features/admin/Tags/tagsAdminSlice";

const EditProduct = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const product = useSelector(selectProductForEditing);
  const isLoading = useSelector(selectLoading);
  const allTags = useSelector(selectAllTags);
  const navigate = useNavigate();
  const location: any = useLocation();
  const { type } = location.state!;
  useEffect(() => {
    !isLoading &&
      batch(() => {
        dispatch(fetchProduct(id, type));
        dispatch(fetchAllTags());
      });
    return () => {
      dispatch(setProductForEdit(undefined));
    };
  }, [id]);

  const onSubmit = (data: any) => {
    const _data = createProduct(data, allTags, type);

    let product = { id: id, data: _data };

    if (type === "product") {
      dispatch(
        updateProduct(product, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
      );
    } else {
      dispatch(
        updateMultisplit(product, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
      );
    }
    navigate("/products", { state: { type } });
  };

  return (
    <>
      <p>
        Мета заглавие (дължина): 20 - 60 знака
        <br />
        Мета тагове (брой): 4 - 9 тага
        <br />
        Мета описание (дължина): 50 - 160 знака
      </p>
      <AdminForm
        formTitle={`Промяна на ${type === "product" ? "климатик" : "мултисплит система"}`}
        onSubmit={onSubmit}
        product={product}
        progress={progress}
      />
    </>
  );
};

export default EditProduct;
